import { useResourcePresence } from '@/hooks/useResourcePresence';
import { Navigate, useSearchParams } from 'react-router-dom';
import { ClaimsTable } from './ClaimsTable';
import { EncountersTable } from './EncountersTable';

export function BillingEncountersPage(): JSX.Element {
  const { presenceByRow, setActiveRow } = useResourcePresence();

  return <EncountersTable presenceByRow={presenceByRow} setActiveRow={setActiveRow} />;
}

export function BillingClaimsPage(): JSX.Element {
  const { presenceByRow, setActiveRow } = useResourcePresence();

  return <ClaimsTable presenceByRow={presenceByRow} setActiveRow={setActiveRow} />;
}

/** Default billing route — encounters, with legacy ?tab=claims redirect. */
export function BillingIndexPage(): JSX.Element {
  const [searchParams] = useSearchParams();
  if (searchParams.get('tab') === 'claims') {
    return <Navigate to="/dashboard/billing/claims" replace />;
  }
  return <BillingEncountersPage />;
}
